import { generateUrl } from '@/util/imageUtils';
import { normlizePath } from '@/util/productFullDetailUtil';

export const generateAddToCartImage = ({ mediaGalleryEntries }) => {
  const image1 = generateUrl(mediaGalleryEntries && mediaGalleryEntries[0]?.file, 'image-product')(90, 132);

  const image2 = normlizePath(image1);

  const hasBasePath =
    !process.env.NEXT_PUBLIC_BASE_PATH ||
    (!!image2 && image2.indexOf(process.env.NEXT_PUBLIC_BASE_PATH.slice(1)) === 0);

  const productImage =
    image2?.indexOf('http') === 0
      ? image2
      : process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL_IMAGE +
        (hasBasePath ? '' : `${process.env.NEXT_PUBLIC_BASE_PATH.slice(1)}/`) +
        image2;

  return productImage;
};
